export class WorkshopSubcontractors {
  id: number = -1;
  parentId:number = -1;
  ownDepot:boolean=false;
  name:string = '';
  contact:string = '';
  address1:string = '';
  address2:string = '';
  city:string = '';
  postcode:string = '';
  phone:string = '';
  email:string = '';
  notes:string = '';
  createdBy: number = -1;
  createdAt: string = '';
  updatedAt: string = '';
}
